/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Barva`
};

const da_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Farve`
};

const de_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Farbe`
};

const en_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Color`
};

const es_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Color`
};

const fr_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Couleur`
};

const hu_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Szín`
};

const it_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Colore`
};

const nl_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Kleur`
};

const pl_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Kolor`
};

const pt_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Cor`
};

const sv_attributes_color = /** @type {(inputs: {}) => string} */ () => {
	return `Färg`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const attributes_color = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.attributes_color(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("attributes_color", locale)
	if (locale === "cs") return cs_attributes_color(inputs)
	if (locale === "da") return da_attributes_color(inputs)
	if (locale === "de") return de_attributes_color(inputs)
	if (locale === "en") return en_attributes_color(inputs)
	if (locale === "es") return es_attributes_color(inputs)
	if (locale === "fr") return fr_attributes_color(inputs)
	if (locale === "hu") return hu_attributes_color(inputs)
	if (locale === "it") return it_attributes_color(inputs)
	if (locale === "nl") return nl_attributes_color(inputs)
	if (locale === "pl") return pl_attributes_color(inputs)
	if (locale === "pt") return pt_attributes_color(inputs)
	return sv_attributes_color(inputs)
};
export { attributes_color as "attributes.color" }